'use client';

import { useRef, useMemo, useEffect } from "react";
import { useLiveAnnouncement } from "../../../utils/hooks/useLiveAnnouncement.js";
import { emptyMsg } from "../Select.data.js";
import { selectAnnouncementOptions } from "./constants.js";
function useAnnouncementForEmpty({
  noOptionsProvided,
  isLoading
}) {
  const isFirstRender = useRef(true);
  const bareAnnounce = useLiveAnnouncement();
  const announce = useMemo(() => {
    const announceOptions = {
      ...selectAnnouncementOptions,
      a11yImportance: "assertive"
    };
    return () => bareAnnounce(emptyMsg, announceOptions);
  }, [bareAnnounce]);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (!isLoading && noOptionsProvided) announce();
  }, [announce, noOptionsProvided]);
}
export {
  useAnnouncementForEmpty
};
